import { ProjektpartList } from '../../components/question/budget/budget.interface';
import { Worksite } from '../../core/models/question/question-worksite.model';

/**
 * Sorts a list of worksites or projektparter alphabetically by company name.
 *
 * Uses TypeScript function overloading to provide type-safe return types:
 * - The first two declarations are overload signatures that tell TypeScript what type to return
 * - The third declaration is the actual implementation that handles both types
 *
 * For Worksite items, sorts by `company.name`
 * For Projektpart items, sorts by `worksite.company.name`
 *
 * @param items - Array of Worksite or Projektpart objects to sort
 * @returns Sorted array of the same type as input
 */
export function sortAlphabetically(items: Worksite[]): Worksite[];
export function sortAlphabetically(items: ProjektpartList): ProjektpartList;
export function sortAlphabetically(items: Worksite[] | ProjektpartList) {
  return items.sort((a, b) =>
    ('worksite' in a ? a.worksite.company.name : a.company.name).localeCompare(
      'worksite' in b ? b.worksite.company.name : b.company.name,
      { sensitivity: 'base' },
    ),
  );
}
